﻿export class AccessibilityElement {

    constructor(public root: HTMLElement) {
        const menu = root.closest('.menu');

        root.addEventListener('focusin', ev => {
            console.warn('Adding active')
            menu.classList.add('active')
        })

        root.addEventListener('blur', ev => {
            menu.classList.remove('active')
        })

        //document.addEventListener('keypress', ev => {
        //    if (ev.key === 'Tab') {
        //        if (document.activeElement === this.root) alert();
        //    }
        //})

    }

}

export class FocusTrap {

    escapeTrap: () => void;

    constructor(public root: HTMLElement) { }

    private createSentinels(el: HTMLElement, lastEl: HTMLElement, firstEl: HTMLElement): () => void {
        const startSentinel = document.createElement('div');
        startSentinel.tabIndex = 0;
        startSentinel.setAttribute('aria-hidden', 'true');
        el.parentElement?.insertBefore(startSentinel, el);

        const endSentinel = document.createElement('div');
        endSentinel.tabIndex = 0;
        endSentinel.setAttribute('aria-hidden', 'true');
        el.parentElement?.insertBefore(endSentinel, el.nextSibling);

        const startFocus = () => lastEl.focus();
        const endFocus = () => firstEl.focus();
        startSentinel.addEventListener('focus', startFocus);
        endSentinel.addEventListener('focus', endFocus);

        return () => {
            startSentinel.removeEventListener('focus', startFocus);
            endSentinel.removeEventListener('focus', endFocus);
            startSentinel.remove();
            endSentinel.remove();
        }
    }

    trapFocus() {
        const modal = this.root;
        const focusableElements = Array.from(modal.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]), label'
        ));

        if (focusableElements.length === 0) {
            modal.tabIndex = -1;
            modal.focus();
            return;
        }

        const firstEl = focusableElements[0];
        const lastEl = focusableElements[focusableElements.length - 1];

        firstEl.focus();

        function handleKeyDown(e: KeyboardEvent) {
            if (e.key !== 'Tab') return;
            console.log("Tabbing", document.activeElement)
            if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstEl) {
                    e.preventDefault();
                    lastEl.focus();
                }
            } else {
                // Tab
                if (!document.activeElement || document.activeElement === lastEl || !modal.contains(document.activeElement)) {
                    e.preventDefault();
                    firstEl.focus();
                }
            }
        }

        modal.addEventListener('keydown', handleKeyDown);

        const fn = this.createSentinels(modal, lastEl, firstEl);

        return () => {
            fn();
            modal.removeEventListener('keydown', handleKeyDown); // cleanup function}
        }
    }
}